import validator from 'validator';
import get from 'lodash/get';

class ModelValidator {

  constructor(data, options = {}) {
    this.data     = data;
    this.options  = options;
    this.errors   = {};
  }

  getAllErrors(validations) {
    const errors = {};

    for (let field in validations) {
      errors[field] = this.getErrors(field, validations[field]);
    }

    return errors;
  }

  getErrors(field, rules) {
    this.playValidations(field, rules);
    return this.errors[field];
  }

  isValid(field, rules) {
    return !this.getErrors(field, rules);
  }

  playValidations(field, rules) {
    const value = get(this.data, field);

    rules.forEach(rule => {
      if (this.errors[field]) return;

      if (!this.getValidateMethod(rule)(value, rule)) {
        this.errors[field] = this.getError(field, rule);
      }
    });
  }

  getValidateMethod(rule) {
    const methodName = this.getRuleName(rule);
    const validateMethod = this[`${methodName}Validator`];
    const isToBePerformed = typeof rule.condition == 'function' ? rule.condition(this.data) : true;
    if (!validateMethod) throw `Unknown validator "${methodName}" in ModelValidator`;
    if (!isToBePerformed) return () => { return true };
    return validateMethod;
  }

  getRuleName(rule) {
    return typeof rule == "string" ? rule : rule.type;
  }

  getError(field, rule) {
    const detail = this.getErrorDetail(field, rule);
    if (detail) return { error: detail };
  }

  getErrorDetail(field, rule) {
    switch(this.getRuleName(rule)) {
      case 'required':
        return { code: "required", message: this.getErrorMessage(field, rule, App.t('errors.required')) };
      case 'requiredArray':
        return { code: "required", message: this.getErrorMessage(field, rule, "Information requise") };
      case 'email': case 'number': case 'phoneNumber':
        return { code: "invalid", message: this.getErrorMessage(field, rule, App.t('errors.required')) };
      case 'taken':
        return { code: "taken", message: this.getErrorMessage(field, rule, "N'est pas disponible") };
      case 'minLength':
        return { code: "minLength", count: rule.count, message: this.getErrorMessage(field, rule, `${rule.count} caractères minimum`) };
      case 'length':
        return { code: "length", count: rule.count, message: this.getErrorMessage(field, rule, `${rule.count} caractères`) };
      case 'mustMatch':
        return { code: "mustMatch", field: rule.field, message: this.getErrorMessage(field, rule, `ne correspond pas`) };
      case 'accepted':
        return { code: "accepted", field: rule.field, message: this.getErrorMessage(field, rule, App.t('errors.required')) };
    }
  }

  getErrorMessage(field, rule, defaultMessage) {
    const messages = this.options.messages;

    if (messages && messages[field] && messages[field][rule]) {
      return messages[field][rule];
    }
    else if (messages && messages._global && messages._global[rule] && messages._global[rule]) {
      return messages._global[rule];
    }
    else {
      return defaultMessage;
    }
  }

  requiredValidator(value) {
    if (typeof value == "number") {
      value = value.toString(); // avoids 0 being falsy
    }

    return value && value.toString().length > 0;
  }

  requiredArrayValidator(value) {
    return Array.isArray(value) && value.length > 0;
  }

  emailValidator(value) {
    return validator.isEmail(value);
  }

  numberValidator(value) {
    if (!value) return true;
    return typeof value == "number";
  }

  minLengthValidator(value, params) {
    if (!value) return true;
    return value.length >= params.count;
  }

  lengthValidator(value, params) {
    if (!value) return true;
    return value.length == params.count;
  }

  mustMatchValidator = (value, params) => {
    return value == this.data[params.field];
  }

  acceptedValidator(value, params) {
    return value === true;
  }

};

export default ModelValidator;
